<template>
  <div class='h100'>
                  <!-- <ejs-button cssClass="e-btn e-control e-primary"  v-on:click.native="deployFun" :isPrimary="true">测试推送</ejs-button> -->

    <ejs-grid ref='grid' height='100%' :dataSource='data' :columns='tableColumns' :allowSorting='true' :rowSelected='onRowSelected'
      :query='gridQuery' :allowReordering='true' :allowResizing='true' :allowExcelExport='true'>
    <e-columns>
      <e-column field='neId' :headerText='$ts("Observe.neId")' width='20%' minWidth='10px' textAlign='Center' clipMode='EllipsisWithTooltip'></e-column>
      <e-column field='sliceId' :headerText='$ts("Observe.sliceId")' width='30%' textAlign='Center' clipMode='EllipsisWithTooltip' minWidth='10px' :visible='sliceIdshow'></e-column>
      <e-column field='moduleNo' :headerText='$ts("Observe.moduleNo")' width='30%' textAlign='Center' clipMode='EllipsisWithTooltip' minWidth='10px'></e-column>
      <e-column field='userId' :headerText='$ts("Observe.userId")' width='30%' textAlign='Center' clipMode='EllipsisWithTooltip' minWidth='10px'></e-column>
      <e-column field='apn' :headerText='apnHeadText' width='30%' textAlign='Center' clipMode='EllipsisWithTooltip' minWidth='10px'></e-column>
      <e-column field='contextId' :headerText='$ts("Observe.contextId")' width='30%' textAlign='Center' clipMode='EllipsisWithTooltip' minWidth='10px'></e-column>
      <e-column field='serviceState' :headerText='$ts("Observe.serviceState")' width='30%' textAlign='Center' clipMode='EllipsisWithTooltip' minWidth='10px'></e-column>
      <e-column field='curRecvEvent' :headerText='$ts("Observe.curRecvEvent")' width='30%' textAlign='Center' clipMode='EllipsisWithTooltip' minWidth='10px'></e-column>
      <e-column field='level' :headerText='$ts("Observe.level")' width='30%' textAlign='Center' clipMode='EllipsisWithTooltip' minWidth='10px'></e-column>
      <e-column field='failcode' :headerText='$ts("Observe.failcode")' width='30%' textAlign='Center' clipMode='EllipsisWithTooltip' minWidth='10px'></e-column>
      <e-column field='time' :headerText='$ts("Observe.failTime")' width='30%' textAlign='Center' clipMode='EllipsisWithTooltip' minWidth='10px'></e-column>
      <e-column field='extMessage' :headerText='$ts("Observe.extBuff")' width='30%' textAlign='Center' clipMode='EllipsisWithTooltip' minWidth='10px'></e-column>
     
     </e-columns>
    </ejs-grid>
    <CustomDialog ref='searchDialog' :element='searchDialogSetting.element' :styles='searchDialogSetting.styles' @afterClose="dialogClose">
      <template v-slot:dialog-content>
        <FormFilter :isImport='isImport' ref='searchContent'></FormFilter>
      </template>
    </CustomDialog>
    <!-- <div class='h-system-hide-upload'>
      <ejs-uploader ref='uploadObj' id='defaultfileupload' name='mFile' :uploading='onUpload' :selected='onSelected'
      :asyncSettings='uploader.path' :autoUpload='uploader.autoUpload' :multiple='false' :allowedExtensions='uploader.extensions'></ejs-uploader>
    </div> -->
  </div>
</template>
<script>
import { Reorder, Resize, ExcelExport, Sort } from '@syncfusion/ej2-vue-grids';
import { DataManager, Query } from '@syncfusion/ej2-data';
import CustomDialog from '../../common/CustomDialog';
import FormFilter from '../util/formFilter/FormFilter';
import bus from '../bus.js';
import { EventBus } from '../../../plugins/eventBus';
import i18n from '../../../plugins/i18n.js';
import socketInstance from '../../../plugins/stompSock';

export default {
  name: 'ImportObserveTable',
  components: {
    CustomDialog,
    FormFilter
  },
  props: {
    isImport: { type: Boolean, default: false },
  },
  data() {
    return {
      sliceIdshow:false,
      pageSettings: {
        pageSizes: [15,30,50,100],
        pageSize: 15
      },
      selectionOptions: { type: 'Multiple' },
      editOptions: { allowAdding: true, allowDeleting: true, newRowPosition: 'Top' },
      sortOptions: { columns: [{ field: 'timeShw', direction: 'Descending' }] },
      locale: localStorage.getItem('locale'),
      dialogFlag: true,
      primaryTableColumns: [],
      tableColumns: [],
      apnHeadText: this.$ts("Observe.apn"),
      queryConditions: {
        conditions: {
          condition: '1'
        }
      },
      directoryName: null,
      data: [],
      filtetAllData: {},
      gridQuery: new Query(),
      primaryDatas: [],
      searchDialogSetting: {
        styles: {
          width: '410px',
          height: this.isImport ? '480px' : '510px',
          model: true,
          visible: false
        },
        element: {
          refName: 'search',
          title: this.$ts('Observe.queryTrack'),
          isClose: true,
          buttonGroup: [
            { click: this.dialogHide, buttonModel: { content: this.$ts('Observe.cancel') } },
            { click: this.searchConfirmFunc, buttonModel: { content: this.$ts('Observe.confirm'), isPrimary: true } }
          ]
        }
      },
      shipColumns: [
        {
          field: 'ShippedDate',
          headerText: 'Shipped Date',
          format: 'yMd',
          textAlign: 'Right',
          width: 150,
          minWidth: 10
        }, {
          field: 'ShipCountry',
          headerText: 'Ship Country',
          width: 150,
          minWidth: 10
        }
      ],
      websocketSetting: [
        { topic: '/user/#/ObserveReportServer', clientId: '', callback: this.websocketCallback }
      ]
    };
  },
  provide: {
    grid: [Reorder, Resize, ExcelExport, Sort]
  },
  methods: {
        deployFun(){
        this.$axios.get(`/lte/ems/observe/queryObserveReportReceive`).then((response) => {
                 });

    },
    $ts(args) {
      const mes = args.split('.');
      const result = (mes[0] && mes[1] && i18n.messages[i18n.locale][mes[0]][mes[1]]) ? i18n.messages[i18n.locale][mes[0]][mes[1]] : args;
      return result;
    },
    getCheckedData(selectOnly) {
      // false: 不支持多选   true: 支持多选
      const selectedRecords = this.$refs.grid.getSelectedRecords();
      if (selectedRecords.length < 1) {
        EventBus.$emit('toast', {type: 'warning', content: this.$ts('Alarm.no_checked')});
        return false;
      }
      if (selectedRecords.length > 1 && !selectOnly) {
        EventBus.$emit('toast', {type: 'warning', content: this.$ts('Alarm.too_many_checked')});
        return false;
      }
      return selectedRecords;
    },
    importTrackFunc() {
      // 导入方法
      document.getElementsByClassName('e-file-select-wrap')[0].querySelector('button').click();
    },
    onSelected(args) {
      if (args.filesData && args.filesData.length > 0) {
        if (args.filesData[0].type !== 'json') {
          EventBus.$emit('toast', {type: 'warning', content: this.$ts('Observe.importFileError')});
        }
      }
    },
    
    exportTrackFunc() {
      const This = this;
      if (This.data.length < 1) {
        EventBus.$emit('toast', {type: 'warning', content: This.$ts('Observe.noDataToExport')});
        return;
      }
      new DataManager({ json: This.data }).executeQuery(This.gridQuery).then((e) => {
        if (false) {//暂时excel导出不支持码流结构体，字节数较大，cell存不下，如果需要支持，建议导出成test文件
          const uuidArr = [];
          let fileName = '';
          if (This.queryConditions.conditions === '') {
            e.result.forEach(node => {
              uuidArr.push(node.uuid);
              if (fileName.indexOf(node.fileName) == -1) {
                fileName = node.fileName + ","
              }
            })
          }
          if (fileName != '') {
            fileName = fileName.substring(0, fileName.length - 1)
          }

          const params = {
            directoryName: This.directoryName,
            fileName: fileName,
            uuidArr: uuidArr,
            tableColumns: This.primaryTableColumns,

          };
          const config = {
            responseType: 'blob'
          };
          This.$axios.post('/lte/ems/observe/observeFileDataExport', params, config).then((res) => {
            const link = document.createElement('a');
            const blob = new Blob([res.data], { type: 'application/vnd.ms-excel' });
            link.style.display = 'none';
            link.href = URL.createObjectURL(blob);
            const num = new Date().getTime();
            link.setAttribute('download', `${this.$ts('Observe.signalDataExport')}.xlsx`);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          });
        } else {
          const exportProperties = {
            fileName: `${This.$ts('Observe.signalDataExport')}.xlsx`,
            dataSource: e.result,
            includeHiddenColumn: true
          };
          This.$refs.grid.excelExport(exportProperties);
        }
      });

    },
    onRowSelected(args) {
      if (args.data.fileName.indexOf('pcap') > -1) {
        return;
      };
      const This = this;
      const params = {
        neId: args.data.neId,
        fileName: args.data.fileName,
        uuid: args.data.uuid
      };
      This.$axios.post('/lte/ems/track/getTreeWithParseCode', params).then((response) => {
        if (response && response.status === 200 && response.data.errorCode === 'SUCCESS') {
          const result = response.data.resultVal;
          This.$emit('rowJson', result);
        } else {
          EventBus.$emit('toast', {type: 'error', content: response.data.errorString});
        }
      });
    },
    dialogClose() {
      this.dialogFlag = true;
    },
    dialogHide() {
      this.$refs.searchDialog.clear();
      this.$refs.searchDialog.close();
    },
    websocketInit() {
      this.websocketSetting[0].clientId = this.observeNowTab ? `observe_${this.observeNowTab.value[0].taskId}` : '';
      if (socketInstance.stompClient == null) {
        socketInstance.init(this.websocketSetting);
      } else {
        socketInstance.dynamicSubscribe(this.websocketSetting[0].topic, this.websocketSetting[0].clientId, this.websocketCallback);
      }
    },
    websocketCallback(msg) {
      console.log("msg====================",msg)
      if (this.queryConditions.conditions.condition !== '0' && this.dialogFlag) {
        // let arr = JSON.parse(msg.body).concat(this.data);//信令管理需要转换 JSON.parse(JSON.stringify
        let newList=[];
        newList.push(JSON.parse(msg.body));
        let arr =newList.concat(this.data);//信令管理需要转换
        if (arr.length > 399) {
          arr.splice(300, arr.length);
        }
        this.data = arr;
        console.log("this.data=========",this.data)
      }
    },
    searchConfirmFunc() {
      // 信令过滤确认事件
      const searchData = this.$refs.searchContent.getDatas();
      if (searchData) {
        this.queryConditions.conditions = searchData;
        this.dialogHide();
        this.searchTaskData();
      }
    },
    searchTask() {
      this.$refs.searchContent.setFilter(this.data);
      this.$refs.searchContent.setDatas(this.queryConditions.conditions);
      this.$refs.searchDialog.show();
      this.dialogFlag = false;
    },
    searchTaskData() {
      const { conditions } = this.queryConditions;
      if (conditions.filterType === '2') {
        this.gridQuery = new Query();
      } else {
        let value = ''
        let conditionsName =  conditions.attributeName;
        if (conditions.attributeValue3 !== '') {
          let time = new Date(conditions.attributeValue3).getTime()/1000 + "000000";
          value = parseInt(time);
          conditionsName = 'timeShw';
        } else if (conditions.attributeValue2 !== '') {
          value = conditions.attributeValue2;
        } else {
          if (conditions.attributeName == 'neId') {
            value = parseInt(conditions.attributeValue1);
          } else {
            value = conditions.attributeValue1;
          }
        }
        const dataQuery = new Query().where(conditionsName, conditions.cron, value);
        this.gridQuery = dataQuery;
      }
    },
    activeObservePage() {
      // 激活任务
      this.$axios.post(`/lte/ems/observe/activeTask/${this.observeNowTab.value[0].taskId}`).then((response) => {
        if (response && response.status === 200 && response.data.errorCode === '0') {
          EventBus.$emit('toast', {type: 'success', content: this.$ts('Observe.success')});
          bus.$emit('refreshObserveTable');
          this.getImportTableData(this.observeNowTab.value);
        } else {
          EventBus.$emit('toast', {type: 'error', content: response.data.errorString});
        }
      });
    },
    hangupObservePage() {
      // 挂起任务
      this.$axios.post(`/lte/ems/observe/pauseTask/${this.observeNowTab.value[0].taskId}`).then((response) => {
        if (response && response.status === 200 && response.data.errorCode === '0') {
          EventBus.$emit('toast', {type: 'success', content: this.$ts('Observe.success')});
          bus.$emit('refreshObserveTable');
          this.getImportTableData(this.observeNowTab.value);
        } else {
          EventBus.$emit('toast', {type: 'error', content: response.data.errorString});
        }
      });
    },
    finishObservePage() {
      // 完成任务
      this.$axios.post(`/lte/ems/observe/finishTask/${this.observeNowTab.value[0].taskId}`).then((response) => {
        if (response && response.status === 200 && response.data.errorCode === '0') {
          EventBus.$emit('toast', {type: 'success', content: this.$ts('Observe.success')});
          bus.$emit('refreshObserveTable');
          this.getImportTableData(this.observeNowTab.value);
        } else {
          EventBus.$emit('toast', {type: 'error', content: response.data.errorString});
        }
      });
    },
    getImportTableData(args) {
      // 获取表格数据
      const This = this;
      if (This.isImport === true) {
        This.directoryName = args[0].directoryName;
        This.$axios.get(`/lte/ems/observe/taskFilesDetail/${args[0].directoryName}/${args[0].fileName}`).then((response) => {
          if (response && response.status === 200 && response.data.errorCode === 'SUCCESS') {
            console.log("response",response)
            const resultData = response.data.resultVal;
            This.data = resultData;
            This.primaryDatas = resultData;
            console.log(This.data);
          } else {
            EventBus.$emit('toast', {type: 'error', content: response.data.errorString});
          }
        });
      } else {
        This.directoryName = args[0].taskId.toString();

      }
    }
  },
  mounted() {
    const observeNowTab = JSON.parse(localStorage.getItem('observeNowTab'));
    this.observeNowTab = observeNowTab;
        console.log("observeNowTab=====",this.observeNowTab)

    const oamTypeCode=this.observeNowTab.value[0].oamTypeCode
    if(oamTypeCode==43||oamTypeCode==44||oamTypeCode==45||oamTypeCode==46||oamTypeCode==47||oamTypeCode==48){
      this.apnHeadText=this.$ts('Observe.callID')
      this.sliceIdshow=false;
    }
    else{
      this.sliceIdshow=true;
    }
    if (!this.isImport) {
      this.websocketInit();
      bus.$on(observeNowTab.name, (args) => {
        this.getImportTableData(args);
      });
    } else {
      bus.$on(observeNowTab.name, (args) => {
        this.getImportTableData(args);
      });
    }
  }
};
</script>
